export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00804.387082f4.png";